import React, { useState } from 'react'
import styled from 'styled-components'
import useClickOutside from '~/hooks/useClickOutside'

import colors from '~/styles/colors'
import { radius } from '~/styles/vars'

export interface TaskMenuProps {
    handleIsEditing: () => void
}

const TaskMenu: React.FC<TaskMenuProps> = ({ handleIsEditing }) => {
    const [isOpen, setIsOpen] = useState(false)
    const menuRef = useClickOutside(() => {
        setIsOpen(false)
    })

    const handleButtonClick = (event: React.MouseEvent) => {
        event.stopPropagation()
        setIsOpen(!isOpen)
    }

    return (
        <Container onClick={handleButtonClick} ref={menuRef}>
            <DotGroup>
                <Dot></Dot>
                <Dot></Dot>
                <Dot></Dot>
            </DotGroup>
    
            {isOpen && (
                <>
                    <Arrow></Arrow>
                    <Menu>
                        <Entry onClick={handleIsEditing}>Modifier</Entry>
                    </Menu>
                </>
            )}
        </Container>
    )
}

const Entry = styled.div`
    color: black;
    width: 100%;
    box-sizing: border-box;
    padding: 1rem 0;
    margin: 0.5rem 3rem;
    border-radius: ${radius.sm};
    :hover {
        background-color: ${colors.variants[500]};
        color: white;
    }
`

const Menu = styled.nav`
    z-index: 10;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 0 0.5rem;
    position: absolute;
    opacity: 1;
    right: 100%;
    top:0;
    background-color: #fff;
    border-radius: ${radius.md};
    box-shadow: 10px 10px 84px 6px ${colors.main[700]} (0, 0, 0, 0.75);
`

const Container = styled.div`
    position: relative;
    display: flex;
    justify-content: space-between;
    padding: 0.5rem 1rem;
    cursor: pointer;
    :hover {
        div > div {
            background-color: white;
            transition: 0.2s ease-in-out;
        }
    }
`

const DotGroup = styled.div`
    display: flex;
    flex-direction: column;
    padding: 0.25rem 0.25rem;
`

const size = '0.5rem'
const Dot = styled.div`
    width: ${size};
    height: ${size};
    margin: 0.25rem 0;
    border-radius: 50%;
    background-color: ${colors.main[300]};
    transition: 0.2s ease;
`

const Arrow = styled.div`
    width: 0;
    height: 0;
    left: 0;
    top: 35%;
    position: absolute;
    border-top: 0.75rem solid transparent;
    border-bottom: 0.75rem solid transparent;
    border-left: 0.75rem solid white;
`

export default TaskMenu
